import styled, { css } from 'styled-components';
import { SectionHeading } from '../../global/typography';

export const StyledHeading = styled(SectionHeading)`
    text-align: center;

    & > span.--green {
        color: ${props => props.theme.colors.primary};
        display: block;
    }

    @media (max-width: 979px) {
        margin: 0 15px;
        margin-bottom: 10px !important;
    }
`;

export const OfferContainer = styled.div<{
    $tilesSettings?: '2x1' | '3x1' | '4x1' | undefined;
    $marginTop?: '0' | '50px';
}>`
    display: grid;
    gap: 30px;
    margin-top: ${({ $marginTop }) => $marginTop};

    ${({ $tilesSettings }) => {
        switch ($tilesSettings) {
            case '2x1':
                return css`
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    flex: 1;
                `;
            case '4x1':
                return css`
                    grid-template-columns: repeat(4, minmax(0, 1fr));
                    flex: 1;
                `;
            case '3x1':
            default:
                return css`
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                    flex: 1;
                `;
        }
    }}
    @media (max-width: 979px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 757px) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
`;

// Setting the default prop value
OfferContainer.defaultProps = {
    $tilesSettings: '3x1',
};

export const SliderControlDiv = styled.div`
    background: rgba(238, 238, 238, 1);
    width: 100%;
    padding: 1.5rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 979px) {
        font-size: 18px;
    }

    & > div {
        width: 8px;

        & > svg {
            width: 100%;
        }
    }
`;
